const Login = async (username, password) => {
    try {
        const dataToSend = {
            username: username,
            password: password
        }

        const baseUrl = process.env.REACT_APP_API_URL
            ? (process.env.REACT_APP_API_URL.endsWith('/') ? process.env.REACT_APP_API_URL : `${process.env.REACT_APP_API_URL}/`)
            : '/api/'

        const response = await fetch(`${baseUrl}Authentication/login`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend)
            })

        if (!response.ok) {
            let errorMessage = 'No ha sido posible iniciar sesión. Inténtalo nuevamente o inténtalo más tarde.'
            try {
                const error = await response.json()
                if (error && error.message) {
                    errorMessage = error.message
                }
            } catch {
                // response is not JSON
            }
            return { success: false, message: errorMessage }
        }

        let data = null;
        try {
            data = await response.json();
        } catch {
            data = null;
        }

        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar iniciar sesión. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

export { Login };